import { render } from "./ZHWLRJKF.vue?vue&type=template&id=9c8f3610"
import script from "./ZHWLRJKF.vue?vue&type=script&lang=js"
export * from "./ZHWLRJKF.vue?vue&type=script&lang=js"

import "./ZHWLRJKF.vue?vue&type=style&index=0&id=9c8f3610&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__